const QUERIES = {
  USERS_LIST: 'users-list',
  Value_List : 'Value-list',
  Gallery_List : 'Gallery-list',
  Attach_list : 'Attach-list',
}

export {QUERIES}
